// extracted by css-extract-rspack-plugin
export default {"iconBackground":"discord-georestrictions-tooltip-module__iconBackground___aWPnw","tooltipContent":"discord-georestrictions-tooltip-module__tooltipContent___Sw3Ff"};